<template>
    <div class="attachment-card" :class="{'attachment-card--in-group': inGroup}" :data-qa="itemId">
        <div class="attachment-card__interaction">
            <button class="border-2 rounded-[4px] w-[28px] h-[28px] md:w-[20px] md:h-[20px] flex justify-center items-center text-xs transition-colors duration-200 ease-in-out" :class="attachmentChecked ? 'border-green-accessible' : ''" @click.prevent="toggleItem()" data-qa="check-box-toggle">
                <span class="sr-only">Include {{ itemName }}</span>
                <Transition name="check-mark">
                    <span v-if="attachmentChecked" class="icon-checkmark text-green-accessible"></span>
                </Transition>
            </button>
        </div>
        <div class="attachment-card__details">
            <p class="text-base font-medium" data-qa="item-name">{{ itemName }}</p>
            <p class="text-xs mt-1" v-if="itemDescription" data-qa="item-description">{{ itemDescription }} <Link v-if="learnMore" @click.prevent="openLearnMore()" no-underline css-underline data-qa="learn-more">Learn more</Link></p>
        </div>
        <div class="attachment-card__price">
            <p class="text-lg font-sans font-normal leading-none md:leading-none mb-2" data-qa="item-total"><span class="text-xl font-bold"><span v-text="$store.getters.currencyPrefix"></span>{{ priceFormat(itemPricing) }}</span><span v-if="itemType != 'charge'">/{{ billingPeriod }}</span></p>
            <p class="text-s font-medium leading-none" v-if="$store.getters.isYearly && yearlyPrice">Paid yearly &mdash; <span v-text="$store.getters.currencyPrefix"></span>{{ priceFormat(yearlyPrice) }}/yr</p>
        </div>
        <Modal ref="learnMoreModal" v-if="learnMore" :qa-name="`${itemId}_learnMore_modal`">
            <h1 class="text-xl font-bold mb-3">{{ learnMore.title }}</h1>
            <p v-for="paragraph, key in learnMore.content" :key="key" class="mb-4 last:mb-0" v-html="paragraph"></p>
        </Modal>
    </div>
</template>

<script>
import * as Analytics from '@/Util/reporting.js';
import { priceFormat } from '@/Util/helpers.js';
import Link from '@/Components/Link.vue';
import Modal from '@/Components/Modal.vue';

export default {
    data() {
        return {
            attachmentChecked: false,
        };
    },
    components: {
        Link,
        Modal,
    },
    mounted() {
        this.attachmentChecked = !!this.lineItems.find(item => item.itemId === this.itemId);
    },
    props: {
        inGroup: {
            type: Boolean,
            default: false,
        },
        itemId: String,
        itemName: String,
        itemDescription: {
            type: [String, Boolean],
            default: false,
        },
        itemPricing: [String, Number],
        billingPeriod: {
            type: String,
            default: 'mo',
        },
        learnMore: Object,
        yearlyPrice: {
            type: [String, Number, Boolean],
            default: false,
        },
        itemType: String,
    },
    emits: [
        'checked',
        'unchecked',
    ],
    methods: {
        priceFormat,
        openLearnMore() {
            this.$refs.learnMoreModal.openModal();

            Analytics.pushToDataLayer({
                event: 'click',
                attributes: {
                    section: 'More info modal',
                    action: 'Modal opened',
                    event_label: this.itemId,
                },
            });
        },
        toggleItem() {
            this.attachmentChecked = !this.attachmentChecked;
            if (this.attachmentChecked) {
                this.$emit('checked');
            } else {
                this.$emit('unchecked');
            }
        }
    },
    created() {
    },
    computed: {
        lineItems() {
            return [
                ...this.$store.state.cartInfo.selectedAddons,
                ...this.$store.state.cartInfo.selectedCharges,
            ];
        },
    },
    watch: {
    }
};
</script>

<style lang="postcss" scoped>

.attachment-card {
    @apply border-gray-4 border-2 rounded-medium p-3 flex flex-col md:flex-row gap-4 md:items-start;

    &--in-group {
        @apply md:border-none;
    }

    &__interaction {
        @apply flex-shrink-0 grid grid-cols-2 gap-2.5 self-start mt-1;
    }

    &__details {
        @apply flex-grow;
    }

    &__price {
        @apply flex-shrink-0 self-start text-left md:text-right;
    }
}

.check-mark-enter-active,
.check-mark-leave-active {
    @apply transition-opacity duration-200 ease-in-out;
}

.check-mark-enter-from,
.check-mark-leave-to {
    @apply opacity-0;
}
</style>
